import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function FailedAttempts() {
  const failures = [{
    title: 'Motivación Barata',
    desc: "Los videos de motivación solo te dan un 'subidón' de 10 minutos que desaparece al primer obstáculo."
  }, {
    title: 'Planes de 90 Días',
    desc: 'Son demasiado largos y terminas abandonando en la primera semana por falta de tracción.'
  }, {
    title: 'Cambio Radical',
    desc: 'Intentar cambiar 10 hábitos a la vez colapsa tu fuerza de voluntad antes del mediodía.'
  }, {
    title: "Esperar 'Suerte'",
    desc: 'Delegar tu éxito en la suerte es la forma más rápida de garantizar el fracaso en un país tan competitivo como USA.'
  }];
  return <section className="py-24 bg-tactical-panel border-b border-tactical-border" data-id="element-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-21">
        <FadeIn data-id="element-22">
          <div className="mb-12" data-id="element-23">
            <h2 className="text-3xl sm:text-4xl font-bold uppercase mb-4 border-l-4 border-red-500 pl-4" data-id="element-24">
              Por qué lo que intentaste no funcionó
            </h2>
            <p className="text-zinc-400 text-lg font-mono uppercase tracking-wider" data-id="element-25">
              [ Análisis de Fallos Previos ]
            </p>
          </div>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-26">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="bg-tactical-dark border border-zinc-800 p-6 relative overflow-hidden" data-id="element-27">
              {/* Background X */}
              <X className="absolute -right-4 -top-4 w-32 h-32 text-red-500/5 pointer-events-none" data-id="element-28" />

              <div className="flex items-start gap-4 mb-4 relative z-10" data-id="element-29">
                <div className="mt-1 bg-red-500/10 p-1 border border-red-500/20" data-id="element-30">
                  <X className="w-5 h-5 text-red-500" data-id="element-31" />
                </div>
                <h3 className="font-oswald text-xl uppercase tracking-wide text-zinc-200" data-id="element-32">
                  {item.title}
                </h3>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed relative z-10" data-id="element-33">
                {item.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}